import React from 'react'
import type { Icon } from 'shared/utils'

const Soy = (props: Icon) => {
    const { color = 'black', size = 24, className = 'soy' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <g fillRule="evenodd">
                <path d="M20.317 2.448c.137 13.599-11.351 19.247-11.351 19.247 18.067-3.454 11.35-19.247 11.35-19.247" />
                <path d="M11.922 15.538a1.214 1.214 0 0 1 1.717 0h.001c.474.473.476 1.24.003 1.715l-.003.003a1.215 1.215 0 0 1-1.718-1.718m1.499-2.852l.002-.001a1.56 1.56 0 0 1 2.205-.002l.001.002c.61.608.61 1.596.002 2.205l-.002.001a1.56 1.56 0 1 1-2.209-2.205m1.856-3.127a1.56 1.56 0 0 1 2.207 0c.61.608.611 1.595.003 2.205l-.002.002a1.561 1.561 0 0 1-2.208-2.207m1.522-2.522a1.215 1.215 0 0 1 1.78 1.654 1.215 1.215 0 1 1-1.78-1.654m.912-2.105a.867.867 0 1 1 1.227 1.227.867.867 0 0 1-1.227-1.227m-6.053 13.975a.867.867 0 1 1-1.226-1.226.867.867 0 0 1 1.226 1.226M9.084 21.17c.8-.448 3.083-1.842 5.33-4.296a21.062 21.062 0 0 0 3.82-5.861c1.1-2.547 1.66-5.312 1.674-8.228 0-.11.002-.222 0-.333 0-.027.005-.054.008-.08C12.037 9.897 2 13.86 2 13.86c3.916 1.253 6.988 1.307 9.4.65-1.37 3.057-2.062 5.602-2.316 6.658" />
            </g>
        </svg>
    )
}

export { Soy }
